// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"c8f42d96","787":"41b11063"}[chunkId] + ".chunk.js";
};